import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, patchRequest, postRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import { ReferralChannelParams } from 'redux/channels/types';

/*
 * Params:
 *       referrel ID = {ID}
 */
export const fetchReferralChannelsByOrgId = async (
  organisationId: ReferralChannelParams
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/channels?fields=*`
  );
  const result =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return result;
};
/*
 * Params:
 *       referrel ID = {ID}
 */
export const fetchActiveChannelsSevice = async (
  organisationId: ReferralChannelParams
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/channels?fields=*&filter=status:LIVE`
  );
  const response =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return response;
};
/*
 * Params:
 *       referrel ID = {ID}
 */
export const fetchDraftChannelsService = async (
  organisationId: ReferralChannelParams
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/channels?fields=*&filter=status:DRAFT`
  );
  const response =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return response;
};

// GET
export const fetchActiveChannelById = async (
  organisationId: string,
  channelId: string
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/channels/${channelId}`
  );
  return await getRequest(AppService, urlBuilder.toString());
};

// PATCH
export const updatedReferralChannel = async ({
  organisationId,
  channelId,
  requestBody
}: ReferralChannelParams) => {
  const payload = {
    ...requestBody
  };
  const urlBuilder = await createUrlBuilder(
    `/community/organisations/${organisationId}/channels/${channelId}`
  );
  const response = await patchRequest(
    AppService,
    urlBuilder.toString(),
    payload
  );
  return response;
};

export const addNewReferralChannel = async ({
  organisationId,
  requestBody
}: ReferralChannelParams) => {
  const payload = {
    ...requestBody
  };
  const urlBuilder = await createUrlBuilder(
    `/community/organisations/${organisationId}/channels`
  );
  const response = await postRequest(
    AppService,
    urlBuilder.toString(),
    payload
  );
  return response;
};

export const fetchGMLProjection = async () => {
  const urlBuilder = createUrlBuilder(`/system/domains/GML_PROJECTION`);
  const result =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return result;
};
